<div class="db-custom-rules" *ngIf="!notConnected || website?.domain_hash">
  <div>
    <db-cdn-notice  [websiteId]="website?.id"></db-cdn-notice>
    <db-booster-notices [websiteId]="website?.id"></db-booster-notices>
    <div class="ds-notification-warning ds-notification-error" *ngIf="boosterUpdateAvailable && (boosterPluginIsActive || boosterPluginIsOld)">
      <div>
        <i class="db-icon db-icon-ds-info-bg"></i>
        <p>
          <b>Update Required:</b> To ensure that optimization continues to work as expected, please update the Booster plugin to the latest version.
        </p>
      </div>
    </div>
    <div class="db-custom-rules__pages-list">
      <db-cdn-enable-banner [websiteId]="website?.id" [longSize]="true" *ngIf="(boosterPluginIsActive || boosterPluginIsOld) && currentSubscription?.boosterProClient"></db-cdn-enable-banner>
      <db-ai-builder-demo-banner *ngIf="demoUser" [title]="'Page management'" [features]="features" [class]="'small without_margin'">
      </db-ai-builder-demo-banner>
      <db-booster-activation-banner *ngIf="!boosterPluginIsActive && !boosterPluginIsOld" [website]="website" [companyName]="companyName" [currentSubscription]="currentSubscription" [fromPages]="true"></db-booster-activation-banner>
      <div class="db-custom-rules__paid" [ngClass]="{'disabled-with-overlay': demoUser}">
        <div class="db-custom-rules__paid-form" [ngClass]="{'paid-client': (currentSubscription?.paidClient || !!website?.domain_hash)}">
          <div *ngIf="!currentSubscription?.paidClient && !website?.domain_hash" class="db-custom-rules__title">
            <div>
              <h1 [innerHTML]="'text_customRulesFree' | dbText"></h1>
              <p class="mt2 mb25" [innerHTML]="'text_customRulesFreeDesc' | dbText"></p>
            </div>
            <div class="db-custom-rules__optimized-pages" *ngIf="optimizedPages?.length < currentSubscription?.plan?.services?.speed_optimizer?.speed_optimizier_optimizable_pages_max_count?.parameter_value">
              <p *ngIf="notOptimizedPagesCount > 0"><i class="db-icon db-icon-ds-exclamation-bg mr4"></i><b class="mr3 {{notOptimizedPagesCount}}">{{notOptimizedPagesCount}} {{notOptimizedPagesCount > 1 ? 'pages' : 'page'}}</b> of your website {{notOptimizedPagesCount > 1 ? 'are' : 'is'}} not yet optimized</p>
              <p class="mt4">
                <i class="db-icon db-icon-ds-diamond mr4"></i>
                <span>
                  <a [routerLink]="['/upgrade-plan']" (click)="onClickEvent(!!showPercentOffer)">{{(showPercentOffer ? 'Optimize all pages at once' : 'Try Booster Pro and optimize all pages')}}
                  </a>
                </span>
              </p>
            </div>
          </div>

          <div *ngIf="(currentSubscription?.paidClient || !!website?.domain_hash)" class="db-custom-rules__header">
            <h2 [innerHTML]="'text_customRulesPaid' | dbText"></h2>
            <p class="mt2">
              <i class="db-icon db-icon-ds-checkmark-bg mr4"></i>
              <span>{{ 'text_allPagesOptimized' | dbText }}</span>
            </p>
            <p class="mt6" *ngIf="(currentSubscription?.paidClient || !!website?.domain_hash)">
              <i class="db-icon db-icon-ds-checkmark-bg mr4"></i>
              <span>{{ 'text_newPagesOptimizedAuto' | dbText }}</span>
            </p>
            <p class="mt6" *ngIf="(currentSubscription?.paidClient || !!website?.domain_hash)">
              <i class="db-icon db-icon-ds-checkmark-bg mr4"></i>
              <span>{{ 'text_allPagesInitiallyOptimized' | dbText }}</span>
            </p>
            <p class="mt6 mb25">
              <i class="db-icon db-icon-{{testModeEnabled ? 'ds-info-bg' : 'ds-checkmark-bg'}} mr4"></i>
              <span>{{testModeEnabled ? ('text_pageCacheDisabled' | dbText) : ('text_cachingEnabled' | dbText) }}</span>
            </p>
          </div>

          <h3 class="mb8" *ngIf="(currentSubscription?.paidClient || !!website?.domain_hash)">{{ 'text_customRulesPaidDesc' | dbText }}</h3>

          <div [ngClass]="{'free-client': !(currentSubscription?.paidClient || !!website?.domain_hash), 'disabled-with-overlay': !boosterPluginIsActive && !boosterPluginIsOld}">
            <div class="ds-input-wrap" *ngIf="(currentSubscription?.paidClient || !!website?.domain_hash) || (!(currentSubscription?.paidClient || !!website?.domain_hash) && optimizedPages?.length < currentSubscription?.plan?.services?.speed_optimizer?.speed_optimizier_optimizable_pages_max_count?.parameter_value)">
              <input [formControl]="pageUrl" type="text"
                     class="ds-input" [ngClass]="{'error': pageUrl.touched && pageUrl.invalid && pageUrl.value !== ''}"
                     [placeholder]="website?.site_url">
              <span class="ds-input-desc" *ngIf="!(currentSubscription?.paidClient || !!website?.domain_hash)">Optimize up to {{currentSubscription?.plan?.services?.speed_optimizer?.speed_optimizier_optimizable_pages_max_count?.parameter_value}} pages within the Free Plan limit, adding them one by one</span>
              <span *ngIf="pageUrl.touched && pageUrl?.invalid && pageUrl?.value !== '' || serverError" class="ds-input-error-msg"
                    [innerHTML]="pageUrl?.errors && pageUrl?.errors['required'] ? 'This field is required.' :
                      pageUrl?.errors?.pattern ? 'No match found' : serverError"></span>
            </div>
            <div class="ds-notification-warning ds-notification-error" *ngIf="!!website?.domain_hash && optimizedPages?.length >= currentSubscription?.plan?.services?.speed_optimizer?.speed_optimizier_optimizable_pages_max_count?.parameter_value">
              <div>
                <i class="db-icon db-icon-ds-info-bg"></i>
                <p>
                  <b>You’ve reached the Free Plan limit.</b> {{(showPercentOffer ? 'text_upgrade' : 'text_tryBoosterForFree') | dbText}} to automatically optimize all pages.
                </p>
              </div>
            </div>
            <a class="ds-btn-green" [ngClass]="{
            'ds-btn-disabled': ((pageUrl.invalid || pageUrl.value === '' || loading) && !showUpgrade)
            }"
               (click)="validatePageUrl(!(currentSubscription?.paidClient || !!website?.domain_hash) && optimizedPages?.length >= (currentSubscription?.plan?.services?.speed_optimizer?.speed_optimizier_optimizable_pages_max_count?.parameter_value))">
              <span *ngIf="!loading"
                    [innerHTML]="((currentSubscription?.paidClient || !!website?.domain_hash) ? 'text_customRulesBtnPaid' : (showUpgrade ? (showPercentOffer ? 'text_upgrade' : 'text_tryForFree') : 'text_customRulesBtn') ) | dbText | lowerCaseSpecificWords"></span>
              <span class="ds-spinner-circle"  *ngIf="loading"></span>
            </a>
          </div>
        </div>
      </div>
      <div class="db-custom-rules__paid mt20" [ngClass]="{'disabled-with-overlay': demoUser}" *ngIf="!!optimizedPages?.length">
        <div>
          <div class="db-custom-rules__list-header">
            <p>{{ 'text_url' | dbText }}</p>
            <p>{{ 'text_lastOptimized' | dbText }}</p>
            <p>{{ 'text_status' | dbText }}</p>
            <p [dsTooltip]="actionRef" [dsTooltipMode]="'hoverStatic'" [dsTooltipLeftPxs]="7"
               dsTooltipPosition="bottom" dsTooltipAlign="right" [dsTooltipVisible]="!(currentSubscription?.paidClient || !!website?.domain_hash)">Level <i *ngIf="currentSubscription?.trialBoosterClient" class="db-icon db-icon-ds-diamond ml4"></i></p>
            <p>{{ 'text_score' | dbText }}</p>
            <ng-template #actionRef>
              <div class="db-modes-list__upgrade-tooltip">Custom optimization levels are<br/> available on {{ companyName }} Booster Pro.<br/> <a [routerLink]="['/upgrade-plan']">{{showPercentOffer ? 'upgrade' : ('text_tryForFree' | dbText)}}</a></div>
            </ng-template>
          </div>
          <div  [ngClass]="{'ds-lazy-load': optimizedPagesLoading}">
            <div class="db-custom-rules__list-item"
                 *ngFor="let page of optimizedPages; let index = index">
              <a target="_blank" rel="noopener"
                 [dsTooltip]="'<p style=\'font-weight: 600; color: #323A4580;\'>URL</p><b class\'.ds-tooltip-title\'>' + page?.url + '</b>'"
                 dsTooltipPosition="bottom"
                 [href]="page?.url" [innerHTML]="page?.url === website?.site_url ? page?.url : (page?.url | trimHomeUrl:  website?.site_url)"></a>
              <p [innerHTML]="page?.date ? ((page?.date * 1000) | date: 'y-MM-dd h:mm:ss') : 'Just now'"></p>
              <i class="db-icon db-icon-{{(modeChangesMode === 'no_optimize' || page?.mode === 'no_optimize') ? 'ds-close-bg' : 'ds-checkmark-bg green'}}"
                 [dsTooltip]="(modeChangesMode === 'no_optimize' || page?.mode === 'no_optimize') ? 'Not Optimized' : 'Optimized'" dsTooltipPosition="bottom"
                 dsTooltipSize="small" dsTooltipColor="black"
                 *ngIf="page?.status !== 'loading'"></i>
              <span class="ds-spinner-circle"  *ngIf="page?.status === 'loading'"></span>
              <db-modes-list [index]="index" [websiteId]="website?.id"
                             [defaultModeLevel]="boosterMode" [userSubscription]="currentSubscription"
                             [trialBoosterClient]="currentSubscription?.trialBoosterClient"
                             [showPercentOffer]="showPercentOffer"
                             [paidClient]="(currentSubscription?.paidClient || !!website?.domain_hash)"
                             [pageId]="page?.id" [pageMode]="page?.mode" (modeChanged)="submitted($event)"></db-modes-list>
              <div>
                <i class="db-icon db-icon-ds-performance actions" [dsTooltip]="'text_checkYourPageSpeedScore' | dbText" dsTooltipAlign="right"
                   dsTooltipColor="black" dsTooltipSize="small" dsTooltipMode="hover" (click)="redirectToGPSI(page?.url)" ></i>
                <i class="db-icon db-icon-ds-more actions" *ngIf="(page?.id !== 'front_page' && currentSubscription?.trialBoosterClient) || !currentSubscription?.trialBoosterClient"
                   [dsTooltip]="pageActionsRef" dsTooltipAlign="right"
                   dsTooltipSize="small" dsTooltipMode="click"></i>
                <ng-template #pageActionsRef>
                  <p (click)="removePage(page?.id)">{{ 'text_remove' | dbText }}</p>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="db-trouble-instructions" *ngIf="notConnected && !website?.domain_hash">
  <div>
    <db-booster-trouble-instructions [insideWebsite]="true" [website]="website" [currentSubscription]="currentSubscription"></db-booster-trouble-instructions>
  </div>
</div>
